import axios from "axios";
import { sbInsert } from "./supabase";

// Backend API base URL.
// In development, REACT_APP_BACKEND_URL points at the local FastAPI server.
// In production builds leave it unset (or empty) so requests go to the same
// origin the site is served from — e.g. https://catalyst7.in/api/...
const base = process.env.REACT_APP_BACKEND_URL || "";

export const API = `${base}/api`;

// Submit a form: try the backend API first (it also sends the email
// notification); if the backend is unreachable (static hosting), write the
// row directly to Supabase instead.
export async function submitForm(apiPath, table, payload) {
  try {
    await axios.post(`${API}${apiPath}`, payload, { timeout: 8000 });
  } catch (err) {
    // Backend answered with a validation/server error — surface it.
    if (err.response) throw err;
    // Backend not reachable — fall back to Supabase directly.
    await sbInsert(table, payload);
  }
}
